/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./compat-abtest.component";
import * as i2 from "../app/@shared/abtest/abtest.service";
var styles_CompatABTestComponent = [];
var RenderType_CompatABTestComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_CompatABTestComponent, data: {} });
export { RenderType_CompatABTestComponent as RenderType_CompatABTestComponent };
export function View_CompatABTestComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, null, null, null, null, null, null, null))], null, null); }
export function View_CompatABTestComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "webapp-compat-abtest", [], null, null, null, View_CompatABTestComponent_0, RenderType_CompatABTestComponent)), i0.ɵdid(1, 114688, null, 0, i1.CompatABTestComponent, [i2.ABTest], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CompatABTestComponentNgFactory = i0.ɵccf("webapp-compat-abtest", i1.CompatABTestComponent, View_CompatABTestComponent_Host_0, {}, {}, []);
export { CompatABTestComponentNgFactory as CompatABTestComponentNgFactory };



// WEBPACK FOOTER //
// ./src/compat/compat-abtest.component.ngfactory.js.pre-build-optimizer.js